import React from "react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import AdminLayout from "./AdminLayout";
import UserLayout from "./UserLayout";

const RoleBasedLayout = ({ children, activeTab = "dashboard" }) => {
  const navigate = useNavigate();
  const toastDisplayed = useRef(false);

  const role = localStorage.getItem("user_role");

  useEffect(() => {
    const checkTokenExpiry = () => {
      const tokenExpiry = localStorage.getItem("access_token");
      const currentTime = Date.now();

      if (!tokenExpiry || currentTime > tokenExpiry) {
        if (!toastDisplayed.current) {
          localStorage.removeItem("Token");
          localStorage.removeItem("TokenExpiry");
          navigate("/");
          toast("Session Expired! Please login again.", {
            icon: "⚠️",
          });
          toastDisplayed.current = true;
        }
      }
    };

    checkTokenExpiry();
  }, [navigate]);

  // Handle invalid role redirect
  useEffect(() => {
    if (
      !role ||
      (role !== "Admin" && role !== "Annotator" && role !== "Reviewer")
    ) {
      navigate("/");
    }
  }, [role, navigate]);

  // Role-based layout rendering
  if (role === "Admin") {
    return <AdminLayout activeTab={activeTab}>{children}</AdminLayout>;
  } else if (role === "Annotator" || role === "Reviewer") {
    return <UserLayout activeTab={activeTab}>{children}</UserLayout>;
  } else {
    // If no valid role, return null while redirect happens
    return null;
  }
};

export default RoleBasedLayout;
